export default __webpack_public_path__ + "static/media/small.a2d7b2ce.jpg";